import './style.scss';

export function about_us_hero_block() {
  const block = document.querySelector('.about_us_hero_block');
  if (!block) return;

  const videoBtn = block.querySelector('.profile-thumb');
  const modal = block.querySelector('.video-modal');
  const videoModal = block.querySelector('.video-modal video');
  const closeBtn = block.querySelector('.close-modal');

  if (!videoBtn || !modal || !videoModal || !closeBtn) return;

  const openModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    modal.classList.add('show');
    document.documentElement.classList.add('modal-opened');
    videoModal.play().catch(() => { });
  };

  const closeModal = () => {
    modal.classList.remove('show');
    document.documentElement.classList.remove('modal-opened');
    videoModal.pause();
  };

  videoBtn.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('show')) {
      closeModal();
    }
  });
}
